<template>
	<main class="mypage password_change">
		<FieldPasswordValidate
			v-model:password="member_password"
			v-model:passwordRe="member_password_re"
			:password_error="errors.member_password"
			:passwordRe_error="errors.member_password_re"
			@update:password="onChangePw"
			@update:password-re="onChangePwRe"
			@on-click-change-pw="onClickChangePw"
		/>
	</main>
</template>

<script setup lang="ts">
// core
import { useRoute, useRouter } from 'vue-router';
// validation
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// api
import { useResetMemberPasswordApi } from '@/api/auth';
// component
import FieldPasswordValidate from '@/components/form/FieldPasswordValidate.vue';
// constant
import { passRegex } from '@/constants/regex';
// constant
import {
	CHANGE_PW,
	COMPANY_TITLE,
	ERROR_PASSWORD_REQUIREMENTS,
	ERROR_PASSWORD_SAME_AS_CURRENT,
	ERROR_PASSWORDS_DO_NOT_MATCH,
} from '@/constants/title';
import { usePopupStore } from '@/stores/popup';
// store
import { useToastStore } from '@/stores/toast';

// -----variable-----
const toastStore = useToastStore();
const popupStore = usePopupStore();
const router = useRouter();
const route = useRoute();

// -----validation-----
const {
	errors,
	defineField,
	validate,
	// handleSubmit,
} = useForm({
	validationSchema: yup.object({
		member_password: yup.string().matches(passRegex, ERROR_PASSWORD_REQUIREMENTS),
		member_password_re: yup.string().oneOf([yup.ref('member_password')], ERROR_PASSWORDS_DO_NOT_MATCH),
	}),
	initialValues: {
		member_password: '',
		member_password_re: '',
	},
});
const [member_password] = defineField('member_password'); //휴대폰번호
const [member_password_re] = defineField('member_password_re'); //휴대폰번호 재입력

// -----api-----
const { mutateAsync: resetMemberPassword } = useResetMemberPasswordApi();

// -----function-----
// 패스워드 입력
const onChangePw = (v: string) => {
	member_password.value = v;
};
// 패스워드 재입력
const onChangePwRe = (v: string) => {
	member_password_re.value = v;
};
// 패스워드 변경
const onClickChangePw = async () => {
	const { valid } = await validate();
	if (!valid) {
		return;
	}
	const res = await resetMemberPassword({
		member_id: route.query.id as string,
		member_password: member_password.value,
	});
	if (res.data.success) {
		toastStore.openToast({
			subContent: COMPANY_TITLE,
			content: CHANGE_PW,
		});
		router.push('/');
	} else {
		popupStore.openPopup({
			content: COMPANY_TITLE,
			subtext: ERROR_PASSWORD_SAME_AS_CURRENT,
		});
	}
};
</script>

<style lang="scss" scoped>
.password_change {
	margin-bottom: 7.2rem;
}
</style>
